import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export function SelectDateTimePicker({ date, setDate }) {
  const handleDateChange = (newValue) => {
    setDate(newValue);
  };
//   console.log("toISOString :", dayjs(date).toISOString());

//   console.log("format :", dayjs(date).format("YYYY-MM-DDTHH:mm:ss.SSS"));
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        format="dd/MM/yyyy hh:mm a"
        value={date ? new Date(date) : null} 
        onChange={handleDateChange}
        className="search-field"
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
          },
        }}
      />
    </LocalizationProvider>
  );
}

export function SelectDatePicker({ date, setDate }) {
  const handleDateChange = (newValue) => {
    setDate(newValue);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        format="dd/MM/yyyy"
        value={date ? new Date(date) : null}
        onChange={handleDateChange}
        className="search-field"
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
          },
        }}
      />
    </LocalizationProvider>
  );
}
